import React from "react";
import { Container, Spinner } from "react-bootstrap";

function Loading (props) {
    return (
      <Container style={{marginTop: 200}} className="text-center pt-5">
        <Spinner className="mx-auto d-block" animation="border" role="status" />
        <span>Loading...</span>
      </Container>
      )
}

export default Loading;